<template>
	<div class="btn-on-class-picker">
		<a :id="`popover-target-${okey}`" tabindex="0" class="btn btn-secondary">
			<div class="btn-on-class-picker__color" :class="option.cssclass"></div>
		</a>
		<b-popover :target="`popover-target-${okey}`" triggers="focus" placement="top" ref="popover">
		<template #title>{{ $t('select-on-style') }}</template>
		<template v-for="color in ['','bad','good']">
			<b-button :key="color" @click="selectBtnOnClass(option, color)" class="mr-1">
				<div class="btn-on-class-picker__color" :class="`btn-on-${color}`"></div>
			</b-button>
		</template>
		</b-popover>
	</div>
</template>

<script>
export default {
	components: {
	},
	name: 'ButtonOnClassPicker',
	props: ['option', 'okey'],
	methods: {
    	selectBtnOnClass(option, color) {
    		if(color) {
    			this.$set(option, 'cssclass', `btn-on-${color}`);
    		} else {
    			this.$set(option, 'cssclass', '');
    		}
    		this.$refs.popover.$emit('close')
    	},
	}
};
</script>
